import type { Response } from "~/types";

export function useMemberships() {
  const { apiVersion } = useRuntimeConfig().public;
  const {
    selectedMembership,
    selectedPaymentMethod,
    payMembershipLoading,
    selectedLocation,
    isNavigating,
    couponApplied,
    deal,
    giftCardCode,
    invoice,
  } = storeToRefs(useBusinessStore());
  const toast = useToast();
  const localePath = useLocalePath();

  const prepareFormData = () => {
    const fd = new FormData();
    fd.append("membership_id", String(selectedMembership.value?.id));

    if (selectedPaymentMethod.value?.key === "in_store") {
      fd.append("payment_method_id", selectedPaymentMethod.value?.id.toString());
    } else if (selectedPaymentMethod.value?.key === "gift-card") {
      fd.append("gift_card_code", giftCardCode.value);
      fd.append(
        "payment_method_id",
        selectedPaymentMethod.value?.id.toString()
      );
    } else {
      fd.append(
        "payment_method_id",
        selectedPaymentMethod.value?.id.toString() || ""
      );
    }

    if (selectedPaymentMethod.value?.key === "tap-cc")
      fd.append("tap_token", selectedPaymentMethod.value?.tap_token as string);

    if (couponApplied.value && deal.value)
      fd.append("deal_id", deal.value.id.toString());

    if (selectedPaymentMethod.value?.accept_invoice && invoice.value)
      fd.append("invoice", invoice.value as File);

    return fd;
  };

  const payMembership = async () => {
    try {
      payMembershipLoading.value = true;
      const response: Response<{
        redirect_url: string | null;
        invoice_id: string | number;
      }> = await $larafetch(
        `/api/${apiVersion}/${selectedLocation.value?.identifier}/new-membership`,
        {
          method: "post",
          body: prepareFormData(),
        }
      );

      if (response.code !== 200) return;

      isNavigating.value = true;

      toast.add({
        title: response.message,
        color: "green",
        icon: "i-approved-success",
      });

      if (selectedPaymentMethod.value?.redirect && response.data.redirect_url) {
        await navigateTo(response.data.redirect_url, { external: true });
        return;
      }

      await navigateTo(
        localePath(
          `/${selectedLocation.value?.identifier}/memberships/finished?invoice_id=${response.data.invoice_id}`
        )
      );
    } catch (err) {
      console.error(err);
    } finally {
      payMembershipLoading.value = false;
    }
  };

  return {
    payMembership,
  };
}
